import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function groupItemsByRow(items) {
    const rows = [];
    const tolerance = 8;

    items.forEach((item) => {
        const top = item.offsetTop;
        const row = rows.find((candidate) => Math.abs(candidate.top - top) <= tolerance);

        if (row) {
            row.items.push(item);
            return;
        }

        rows.push({ top, items: [item] });
    });

    return rows.sort((a, b) => a.top - b.top).map((row) => row.items);
}

export function initTeamAnimations() {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    document.querySelectorAll(".block__team__grid").forEach((grid) => {
        const items = Array.from(grid.querySelectorAll(".block__team__member"));
        if (!items.length) return;

        gsap.set(items, { clearProps: "all" });

        if (prefersReduced) return;

        const rows = groupItemsByRow(items);

        gsap.set(items, {
            autoAlpha: 0,
            y: 32,
            force3D: true
        });

        rows.forEach((row) => {
            gsap.to(row, {
                autoAlpha: 1,
                y: 0,
                duration: 0.8,
                ease: "power3.out",
                stagger: 0.12,
                scrollTrigger: {
                    trigger: row[0],
                    start: "top 82%",
                    once: true
                },
                onComplete: () => gsap.set(row, { clearProps: "opacity,visibility,transform" })
            });
        });
    });
}
